import { EntityRepository, Repository } from "typeorm";
import { GrnItems } from "./raw-material-grn-items.entity";

@EntityRepository(GrnItems)
export class GrnItemRepository extends Repository<GrnItems> {

}